import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "skill-dice-roll__wrapper" }
const _hoisted_2 = { class: "skill-dice-roll__roll-result" }
const _hoisted_3 = { class: "skill-dice-roll__roll-result-value" }
const _hoisted_4 = { class: "skill-dice-roll-result__word" }
const _hoisted_5 = { class: "skill-dice-roll-result__value" }
const _hoisted_6 = { class: "skill-dice-roll__is-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RollDifficulty = _resolveComponent("RollDifficulty")!
  const _component_SkillBubble = _resolveComponent("SkillBubble")!
  const _component_RollResult = _resolveComponent("RollResult")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isHitPreRolled && !_ctx.isHitRolled)
        ? (_openBlock(), _createBlock(_component_RollDifficulty, {
            key: 0,
            modelValue: _ctx.difficulty,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.difficulty) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_SkillBubble, {
        bonus: _ctx.bonus,
        "onUpdate:bonus": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bonus) = $event)),
        "is-experience-displayed": _ctx.result.length && _ctx.isHitRolled,
        "experience-gained": _ctx.experienceGained,
        skill: _ctx.skill
      }, null, 8, ["bonus", "is-experience-displayed", "experience-gained", "skill"]),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RollResult, {
          result: _ctx.result,
          size: 40
        }, null, 8, ["result"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.signed(_ctx.resultValue, true)), 1)
      ], 512), [
        [_vShow, _ctx.result.length]
      ]),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["skill-dice-roll-result", `skill-dice-roll-result--${_ctx.getResultWord(_ctx.resultValue, !_ctx.isHitPreRolled && !_ctx.isHitRolled)}`])
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t(
						`${_ctx.isHitPreRolled || _ctx.isHitRolled ? 'roll-hit' : 'roll-result'}__${_ctx.getResultWord(
							_ctx.resultValue,
							_ctx.isHitPreRolled || _ctx.isHitRolled
						)}`
					)), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.signed(_ctx.resultValue, true)), 1)
      ], 2), [
        [_vShow, _ctx.result.length && !(_ctx.isHitPreRolled && !_ctx.isHitRolled)]
      ]),
      _createElementVNode("label", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isRollIsCounts) = $event)),
          class: "skill-dice-roll__is-count-input",
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.isRollIsCounts]
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('auto-increase-xp')), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_Button, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (!_ctx.isHitPreRolled ? _ctx.preRollForHit() : _ctx.isHitPreRolled && !_ctx.isHitRolled ? _ctx.rollForHit() : _ctx.rollForDamage()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(!_ctx.isHitPreRolled ? 'roll__hit--pre' : _ctx.isHitPreRolled && !_ctx.isHitRolled ? 'roll__hit' : 'roll__damage')), 1)
        ]),
        _: 1
      })
    ])
  ], 64))
}